var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.4,154.2C363.5,87,297.7,42.7,224,42.7C124,42.7,42.7,124,42.7,224c0,11.8,1.1,23.4,3.3,34.8 c-28.7,22-46,56.4-46,93.2c0,64.7,47.9,117.3,106.7,117.3H352c88.2,0,160-71.8,160-160C512,235.4,462,172,391.4,154.2z M352,426.7 H106.7c-35.3,0-64-33.5-64-74.7c0-26.9,14.6-51.8,38.1-65.1l14.7-8.3l-4.7-16.2c-3.6-12.4-5.4-25.3-5.4-38.4 c0-76.5,62.2-138.7,138.7-138.7c59.5,0,112.3,37.8,131.4,94.2l4.1,12l12.5,2.2c56.4,9.7,97.3,58.3,97.3,115.6 C469.3,374,416.7,426.6,352,426.7L352,426.7z M326.3,271.1l30.2,30.2l-70.3,70.3c-8.3,8.3-19.2,12.5-30.2,12.5s-21.8-4.2-30.2-12.5 l-70.3-70.3l30.2-30.2l48.9,48.9V192h42.7v128L326.3,271.1L326.3,271.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadin);
export default __webpack_public_path__ + "static/media/downloadin.8e186e695d9e4f559a63d43b8c557d3a.svg";
export { ForwardRef as ReactComponent };